/**
 * O bloco `esocial` que o formulário envia (#302).
 *
 * Com o GFIP vindo preenchido pelo cálculo, o bloco passa a ir quase sempre, e as datas vazias
 * (Início e Fim da Condição, Estabilidade) fazem a API recusar com "Data de início deve ser uma
 * data válida" — depois de o funcionário já ter sido criado pela metade. Data vazia é ausência:
 * não vai. Na criação, nenhum campo vazio vai; na edição, Motivo e GFIP vazios seguem, para a
 * pessoa poder apagá-los.
 */

import type { EmployeeFormData } from '../../types/employee';

export type ESocialDoFormulario = EmployeeFormData['esocial'];

const CAMPOS_DE_DATA = ['inicioCondEsocial', 'fimCondEsocial', 'estabilidade'] as const;

export function esocialParaEnvio(
  esocial: Partial<ESocialDoFormulario> | undefined,
  modo: 'criacao' | 'edicao'
): Partial<ESocialDoFormulario> | undefined {
  if (!esocial) return undefined;

  const enviado: Partial<ESocialDoFormulario> = {};
  for (const [campo, valor] of Object.entries(esocial) as Array<[keyof ESocialDoFormulario, string | undefined]>) {
    if (valor === undefined) continue;
    const vazio = valor.trim() === '';
    const ehData = (CAMPOS_DE_DATA as readonly string[]).includes(campo);
    if (vazio && (ehData || modo === 'criacao')) continue;
    enviado[campo] = valor;
  }

  return Object.keys(enviado).length > 0 ? enviado : undefined;
}
